/**
 * @name AppVersion
 * @description Function for the AppVersion service
 * @param {type} $http Description
 * @param {type} ENDPOINT Description
 * @param {type} AlertMessages Description
 * @return {object} Returns the ArtistHours service
 */
function AppVersion(
  $http,
  ENDPOINT,
  AlertMessages
) {
  AppVersion.get = get;

  /**
   * @name get
   * @description Function to get the app version from the API
   * @param {boolean} getDescription Flag to determine if we should get the
   * description for each app version.
   * @return {string} Returns the result of the app version
   */
  function get(getDescription) {
    let url = ENDPOINT.server + 'inkutils/api/v1.1/app-version/';
    if (getDescription) {
      url += '?description=true';
    }
    return $http.get(url)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return AppVersion;
}

angular
  .module('inkfinder')
  .factory('AppVersion', AppVersion);



// WEBPACK FOOTER //
// ./components/app-version/app-version.service.js